<template>
  <div>
    <my-header></my-header>
    <div class="contents">
      <div
        v-if="is_loading"
        class="loading"
      >
        <img src="@/assets/loading.gif">
      </div>
      <div v-else>
        <div
          v-if="companies.length == 0"
          class="no_company"
        >
          対象なし
        </div>
        <div
          v-else
          v-for="(company, index) in companies"
          :key="index"
        >
          <company-card
            :propCompany="company"
            @get_companiesList="get_companiesList"
          ></company-card>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import MyHeader from "@/components/MyHeader";
import companyCard from "@/components/CompanyCard.vue";
import firebase from "firebase";
export default {
  components: {
    companyCard,
    MyHeader
  },
  data() {
    return {
      is_loading: false,
      companies: []
    };
  },
  created() {
    this.get_companiesList();
  },
  methods: {
    get_companiesList() {
      console.log("start get_companiesList");
      this.companies = [];
      const self = this;
      this.is_loading = true;
      this.firestore = firebase.firestore();
      this.firestore
        .collection("favorites")
        .where("uuid", "==", this.$store.state.user.uuid)
        .orderBy("unix_time", "desc")
        .get()
        .then(docs => {
          console.log("[Favorites]get 完了");
          self.is_loading = false;
          docs.forEach(doc => {
            self.companies.push(doc.data());
          });
        })
        .catch(error => {
          console.log("[Favorites]Error getting documents: ", error);
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.contents {
  text-align: center;
  margin-top: 1vh;
  .loading {
    line-height: 80vh;
  }
  .no_company {
    margin-top: 5vh;
    font-size: 1.5rem;
  }
}
</style>
